"use client";

import { cn } from "@/lib/utils";
import { TopSheen } from "./TopSheen";

/**
 * Text field styled to match FlowSelect, so inputs and dropdowns in the flow
 * read as the same control.
 */
export function FlowInput({
  id,
  type = "text",
  value,
  onChange,
  placeholder,
  autoComplete,
  inputMode,
  required,
  ariaLabel,
  className,
}: {
  id?: string;
  type?: "text" | "email" | "tel" | "password";
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
  autoComplete?: string;
  inputMode?: "text" | "email" | "tel";
  required?: boolean;
  ariaLabel?: string;
  className?: string;
}) {
  return (
    <div className={cn("relative w-full", className)}>
      <input
        id={id}
        type={type}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder={placeholder}
        autoComplete={autoComplete}
        inputMode={inputMode}
        required={required}
        aria-label={ariaLabel}
        className="h-14 w-full rounded-lg bg-[#0F1319] px-6 font-suisse-intl-medium text-base text-white placeholder:text-white/40 focus:outline-none focus:ring-1 focus:ring-white/30"
      />
      <TopSheen />
    </div>
  );
}
